export default ['#0061C2', '#409EFF', '#31adfb', '#8FC7FF', '#DEEEFF', '#bbd3fb']//废弃、待处理
export const textColors = ['#000000', '#181818', '#2c2c2c', '#383838', '#5e5e5e', '#808080', '#a6a6a6', '#d1d1d1', '#f1f1f1', '#ffffff']
export const themeGroup = [
    { name: '深色系', colors: ['#00edff', '#a1a1fe', '#faee3a', '#a8e950', '#00a9fe', '#1c5aba', '#f097a3', '#c7f2ff', '#f7af6b'] },
    { name: '白色系', colors: ['#2abf92', '#ffc849', '#a8e950', '#1c5aba', '#00a9fe', '#f7af6b', '#f097a3', '#c7f2ff', '#faee3a'] },
    { name: '科技蓝', colors: ['#0034b5', '#0052d9', '#266fe8', '#4787f0', '#699ef5', '#96bbf8', '#bbd3fb', '#d4e3fc', '#ecf2fe'] },
    { name: '炽热红', colors: ['#951114', '#b11f26', '#c9353f', '#e34d59', '#f36d78', '#f78d94', '#f8b9be', '#f9d7d9', '#fdecee'] },
    { name: '活力橙', colors: ['#842b0b', '#9e3610', '#ba431b', '#d35a21', '#ed7b2f', '#f2995f', '#f7c797', '#f9e0c7', '#fef3e6'] },
    { name: '极光绿', colors: ['#044f2a', '#056334', '#067945', '#078d5c', '#00a870', '#48c79c', '#85dbbe', '#bcebdc', '#e8f8f2'] },
    { name: '富贵紫', colors: ['#572796', '#6d3bac', '#834ec2', '#9963d8', '#ae78f0', '#c68cff', '#d8abff', '#e6c4ff', '#f3e0ff'] },
    { name: '土豪金', colors: ['#754c00', '#8c5f00', '#a37200', '#ba8700', '#d29c00', '#ebb105', '#fbca25', '#ffe478', '#fff8b8'] },
    { name: '玫瑰粉', colors: ['#9b006b', '#bc0088', '#d42c9d', '#ed49b4', '#ff66cc', '#ff8fe1', '#ffb2f2', '#ffd1fc', '#ffe9ff'] },
    { name: '金融', colors: ['#ffd03b', '#ff6a3a', '#ffda98', '#eff4ff', '#ffa13f', '#6a707c', '#ffab90'] },
    { name: '零售', colors: ['#1890ff', '#d83d6c', '#2f54eb', '#abbfe5', '#d3adf7', '#00ceff', '#edbccb'] },
    { name: '政务', colors: ['#159aff', '#66e1df', '#4f84d4', '#d0deee', '#ffc97a', '#e37d4b', '#dd5b5b'] },
    { name: '蓝绿', colors: ['#33cccc', '#7aa3cc', '#dbb36e', '#bfeaff', '#1ec5ea', '#3073b7', '#ffe5b9'] },
    { name: '紫金', colors: ['#6577bf', '#e8cb95', '#e4775e', '#c9cde7', '#525d8b', '#c5a162', '#b97161'] },
    { name: '绿橙', colors: ['#1affe4', '#ff8d3a', '#f9d354', '#e3faf7', '#3c8883', '#dda882', '#f0da8f'] },
    { name: '绿紫', colors: ['#544cff', '#34ce72', '#e6475e', '#4ac0f2', '#d3e1f2', '#ffb6b6', '#aba7ff'] },
    { name: '教务', colors: ['#a43222', '#ffb053', '#6cccff', '#c4c4cc', '#d48c82', '#e4c29a', '#94c2da'] },
]



/**
 *  组件配色字段，设计器切换主题时用到
 * fill：主题色生效的字段列表
 * text：字体色生效的字段列表
 * fill.field：组件option.attribute中的颜色字段名称
 * fill.colorIndex：颜色系数组的index，不填默认为0
 */
export const colorFields = {
    'cpt-dataV-border': {
        fill: [{ field: 'borderColor1', colorIndex: 0 }, { field: 'borderColor2', colorIndex: 1 }]
    },
    'cpt-button': {
        fill: [{ field: 'bgColor', colorIndex: 0 }],
        text: ['textColor']
    },
    'cpt-text': {
        text: ['textColor']
    },
    'cpt-input': {
        text: ['textColor']
    },
    'cpt-total': {
        text: ['textColor']
    },
    'cpt-select': {
        text: ['textColor']
    },
    'cpt-tree': {
        text: ['fontColor']
    },
    'cpt-page': {
        text: ['textColor']
    },
    'cpt-scroll-text': {
        text: ['textColor']
    },
    'cpt-dataV-decoration': {
        fill: [{ field: 'color1', colorIndex: 0 }, { field: 'color2', colorIndex: 1 }],
        text: ['textColor']
    },
    // 'cpt-table': {
    //     fill: [{ field: 'theadBg', colorIndex: 0 }, { field: 'oddRowBg', colorIndex: 1 }, { field: 'evenRowBg', colorIndex: 2 }],
    //     text: ['theadColor', 'tbodyColor']
    // },
    // 'cpt-scroll-table': {
    //     fill: [{ field: 'theadBg' }, { field: 'oddRowBg', colorIndex: 1 }, { field: 'evenRowBg', colorIndex: 2 }],
    //     text: ['theadColor', 'tbodyColor']
    // },
    'cpt-table': {
        fill: [{ field: 'theadBg', colorValue: '#081449' },
        { field: 'tbodyColor', colorValue: '#fff' }, 
        { field: 'theadColor', colorValue: '#6aa9e4' }, 
        { field: 'oddRowBg', colorValue: 'rgba(0,71,143,0.41)' },
         { field: 'evenRowBg', colorValue: 'rgba(18,123,251,0.38)' },
         { field: 'pageNumberColor', colorValue: '#fff' },
         
          { field: 'bordered', value: false }],
        text: []
    },
    'cpt-scroll-table': {
        fill: [{ field: 'theadBg', colorValue: ['#081449', '#081449'] }, { field: 'tbodyColor', colorValue: '#fff' }, { field: 'theadColor', colorValue: '#6aa9e4' }, { field: 'oddRowBg', colorValue: 'rgba(0,71,143,0.41)' }, { field: 'evenRowBg', colorValue: 'rgba(18,123,251,0.38)' }, { field: 'borderType', value: 'none' }],
        text: []
    },
    'cpt-datetime': {
        text: ['textColor']
    },
    'cpt-num': {
        fill: [{ field: 'numColor', colorIndex: 1 }],
        text: ['labelColor']
    },
    'cpt-rect-num': {
        fill: [{ field: 'bgColor', colorIndex: 1 }],
        text: ['color']
    },
    'cpt-tab': {
        // fill: [{ field: 'textColor', colorIndex: 1 }],
        fill: [{ field: 'textColor', colorValue: '#ffffff' }],
        text: ['textColor']
    },
    'cpt-chart-column': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-column-stack': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-column-region': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-scroll-list': {
        fill: [{ field: 'barColor' }],
        text: ['titleTextColor', 'xLabelColor', 'xLineColor', 'yLabelColor', 'barLabelColor']
    },
    'cpt-chart-column-stereo': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'series.label.color']
    },
    'cpt-chart-column-3d': {
        fill: [{ field: 'color' },
        { field: 'yAxis.axisLine.lineStyle.color', colorValue: '#252525' },
        { field: 'yAxis.splitLine.lineStyle.color', colorValue: '#14477e' },
        ],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'xAxis.splitLine.lineStyle.color',
            'yAxis.axisLabel.textStyle.color',
            'title.textStyle.color', 'series.label.color']
    },
    'cpt-chart-pie': {
        fill: [{ field: 'color' },
        { field: 'title.textStyle.color', colorValue: '#ffffff' },
        ],
        text: ['legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-pie-3d': {
        fill: [{ field: 'color' },
        { field: 'title.textStyle.color', colorValue: '#ffffff' },
        ],
        text: ['legend.textStyle.color']
    },
    'cpt-ring-pie': {
        fill: [{ field: 'pieColor' }, 
        { field: 'borderColor', colorValue: '#081449' }
    ],
    },
    'cpt-dataV-activeRing': {
        fill: [{ field: 'color' }, { field: 'fontColor', colorValue: '#fff'}]
    },
    'cpt-dataV-waterLevel': {
        fill: [{ field: 'colors' }]
    },
    'cpt-chart-line': {
        fill: [{ field: 'lineColors' }, { field: 'areaColors' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-candlestick': {
        text: ['title.textStyle.color', 'legend.textStyle.color', 'xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color']
    },
    'cpt-chart-gauge': {
        fill: [
            { field: 'color1', colorValue: '#35D0E6' },
            { field: 'color2', colorIndex: 1, },
            { field: 'color3', colorIndex: 1, },
            { field: 'itemColor', colorValue: '#35D0E6' },
            { field: 'detailColor', colorValue: '#ffffff' },
            // { field: 'pointer.itemStyle.color', colorIndex: 3 },
            { field: 'titleColor', colorValue: '#fff' }
        ],
        text: ['detailColor']
    },
    'cpt-dataV-percentPond': {
        fill: [{ field: 'colors' }, { field: 'textColor', colorValue: '#ffffff' }]
    },
    'cpt-chart-progress-ring': {
        fill: [{ field: 'numColor', colorValue: '#D0E7FF' }, { field: 'progressColor', colorValue: '#35D0E6' },
        { field: 'titleColor', colorValue: '#ffffff' },
        { field: 'numSize', colorValue: 30 },
        { field: 'borderRadius', colorValue: 20 },
        { field: 'progressBg', colorValue: '#00000000' },

        ],
        text: ['titleColor']
    },
    'cpt-chart-scatter': {
        fill: [{ field: 'color' }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color']
    },
    'cpt-chart-radar': {
        fill: [{ field: 'colors' },
        { field: 'legend.left', colorValue: "right" },
        { field: 'legend.top', colorValue: 'top' },
        { field: 'legend.orient', colorValue: 'vertical' },
        { field: 'legend.textStyle.fontSize', colorValue: '14' },
        { field: 'radar.axisName.color', colorValue: '#fff' },
        { field: 'title.textStyle.color', colorValue: '#ffffff' },


        ],
        text: ['legend.textStyle.color']
    },
    'cpt-chart-funnel': {
        fill: [{ field: 'color' }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-map-gc': {
        fill: [{ field: 'color' }],
        text: ['titleColor', 'subTitleColor', 'geoLabelColor', 'visualMap.textStyle.color']
    },
    'cpt-chart-map-migrate': {
        fill: [{ field: 'color' }, { field: 'map.areaColor', colorIndex: 0 }, { field: 'map.borderColor', colorIndex: 4 }, { field: 'map.shadowColor', colorIndex: 1 },
        { field: 'line.lineStyle.color', colorIndex: 3 }, { field: 'line.endPoint.itemStyle.color', colorIndex: 3 }, { field: 'effectScatter.itemStyle.color', colorIndex: 5 }],
        text: ['title.textStyle.color', 'map.color', 'visualMap.textStyle.color']
    },
    'cpt-chart-map-3d': {
        fill: [{ field: 'itemStyle.color', colorIndex: 0 }, { field: 'itemStyle.borderColor', colorIndex: 2 }, { field: 'barColor', colorIndex: 3 }],
        text: ['label.color']
    },
    'cpt-chart-map-3d-line': {
        fill: [{ field: 'color' }, { field: 'itemStyle.borderColor', colorIndex: 4 }, { field: 'itemStyle.color', colorIndex: 3 },
        { field: 'bar.color', colorIndex: 1 }, { field: 'line.lineStyle.color', colorIndex: 4 }],
        text: ['title.textStyle.color', 'label.color', 'visualMap.textStyle.color']
    },
    'cpt-time-run': {
        fill: [{ field: 'num.color', colorIndex: 1 }],
        text: ['label.color']
    },
    'cpt-chart-line-dual': {
        fill: [{ field: 'color' }, { field: 'yAxis[0].axisLine.lineStyle.color', colorIndex: 0 }, { field: 'yAxis[1].axisLine.lineStyle.color', colorIndex: 2 }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'series.label.color']
    },
    'cpt-chart-line-multiple': {
        fill: [{ field: 'color' }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'series.label.color']
    },
    'cpt-chart-polycyclic': {
        fill: [{ field: 'color' }, { field: 'hartColor' }, { field: 'legendColor', colorValue: '#fff' }],
    },
    'cpt-scroll-list': {
        text: ['color'],
    },
    'cpt-water-prop': {
        fill: [{ field: 'outline.borderColorTop', colorIndex: 0 }, { field: 'outline.borderColorBottom', colorIndex: 1 }, { field: 'colorTop', colorIndex: 2 }, { field: 'colorBottom', colorIndex: 3 },
        { field: 'backgroundColorTop', colorIndex: 3 }, { field: 'backgroundColorBottom', colorIndex: 4 },
        { field: 'outline.shadowColor', colorValue: 'rgb(0,0,0)' },


        ],
        text: ['label.color', 'label.insideColor'],
    },
    'cpt-chart-rect-stack': {
        fill: [{ field: 'colors' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color', 'title.textStyle.color']
    },
    'cpt-chart-wordcloud': {
        fill: [{ field: 'color' }]
    },
    'cpt-chart-line-3d': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'xAxis.splitLine.lineStyle.color',
            'yAxis.axisLabel.textStyle.color', 'yAxis.axisLine.lineStyle.color', 'yAxis.splitLine.lineStyle.color',
            'title.textStyle.color', 'series.label.color']
    },
}

export const lightColorFields = {
    'cpt-dataV-border': {
        fill: [{ field: 'borderColor1', colorValue: '#fff' }, { field: 'borderColor2', colorValue: '#fff' }]
    },
    'cpt-button': {
        fill: [{ field: 'bgColor', colorIndex: 0 }],
        text: ['textColor']
    },
    'cpt-text': {
        text: ['textColor']
    },
    'cpt-input': {
        text: ['textColor']
    },
    'cpt-total': {
        text: ['textColor']
    },
    'cpt-select': {
        text: ['textColor']
    },
    'cpt-tree': {
        text: ['fontColor']
    },
    'cpt-page': {
        text: ['textColor']
    },
    
    'cpt-scroll-text': {
        text: ['textColor']
    },
    'cpt-dataV-decoration': {
        fill: [{ field: 'color1', colorIndex: 0 }, { field: 'color2', colorIndex: 1 }],
        text: ['textColor']
    },
    'cpt-table': {
        fill: [{ field: 'theadBg', colorValue: '#ebf6fc' },
        { field: 'theadColor', colorValue: '#203453' },
        { field: 'tbodyColor', colorValue: '#42536d' },
        { field: 'oddRowBg', colorValue: 'rgb(0,0,0,0)' },
        { field: 'evenRowBg', colorValue: '#edf5fa' },
        { field: 'pageSelectBorderColor', colorValue: '#42536d' },
        { field: 'pageNumberColor', colorValue: '#42536d' },
        { field: 'bordered', value: true }],
        text: ['theadColor', 'tbodyColor']
    },
    'cpt-scroll-table': {
        fill: [{ field: 'theadBg', colorValue: ['#ebf6fc', '#ebf6fc'] }, { field: 'theadColor', colorValue: '#203453' }, { field: 'tbodyColor', colorValue: '#42536d' }, { field: 'oddRowBg', colorValue: 'rgb(0,0,0,0)' }, { field: 'evenRowBg', colorValue: 'rgb(0,0,0,0)' }, { field: 'borderType', value: 'button' }, { field: 'borderColor', colorValue: '#edf4f4' }],
        text: ['theadColor', 'tbodyColor']
    },
    'cpt-datetime': {
        text: ['textColor']
    },
    'cpt-num': {
        fill: [{ field: 'numColor', colorIndex: 1 }],
        text: ['labelColor']
    },
    'cpt-rect-num': {
        fill: [{ field: 'bgColor', colorIndex: 1 }],
        text: ['color']
    },
    'cpt-tab': {
        fill: [{ field: 'textColor', colorIndex: 1 }],
    },
    'cpt-chart-column': {
        fill: [{ field: 'color' },
        { field: 'yAxis.axisLabel.color', colorValue: "#5d6b81" },
        ],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-column-stack': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-column-region': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-scroll-list': {
        fill: [{ field: 'barColor' }],
        text: ['titleTextColor', 'xLabelColor', 'xLineColor', 'yLabelColor', 'barLabelColor']
    },
    'cpt-chart-column-stereo': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'series.label.color']
    },
    'cpt-chart-column-3d': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'xAxis.splitLine.lineStyle.color',
            'yAxis.axisLabel.textStyle.color', 'yAxis.axisLine.lineStyle.color', 'yAxis.splitLine.lineStyle.color',
            'title.textStyle.color', 'series.label.color']
    },
    'cpt-chart-pie': {
        fill: [{ field: 'color' }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-pie-3d': {
        fill: [{ field: 'color' }, { field: 'legend.textStyle.color', colorValue: '#5d6b81' }],
        text: ['title.textStyle.color']
    },
    'cpt-ring-pie': {
        fill: [{ field: 'pieColor' }, { field: 'borderColor', colorValue: '#000' }],
    },
    'cpt-dataV-activeRing': {
        fill: [{ field: 'color' }, { field: 'fontColor', colorValue: '#5d6b81'}]
    },
    'cpt-dataV-waterLevel': {
        fill: [{ field: 'colors', colorValue: ['#66c8cc', '#50aaad'] }]
    },
    'cpt-chart-line': {
        fill: [{ field: 'lineColors' }, { field: 'areaColors' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color',
            'title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-candlestick': {
        text: ['title.textStyle.color', 'legend.textStyle.color', 'xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color']
    },
    'cpt-chart-gauge': {
        fill: [
            { field: 'color1', colorValue: '#35D0E6' },
            { field: 'color2', colorValue: '#8aff40' },
            { field: 'color3', colorValue: '#bf3737' },
            { field: 'itemColor', colorValue: '#35D0E6' },
            { field: 'detailColor', colorValue: '#5d6b81' },

            { field: 'pointer.itemStyle.color', colorValue: '#35D0E6' },
            { field: 'titleColor', colorValue: '#5d6b81' },
        ],
        text: ['detailColor', 'axisLabel.color', 'axisTick.lineStyle.color']
    },
    'cpt-dataV-percentPond': {
        fill: [{ field: 'colors', colorValue: ['#35D0E6', '#409EFF'] }, { field: 'textColor', colorValue: '#5d6b81' }]
    },
    'cpt-chart-progress-ring': {
        fill: [{ field: 'numColor', colorValue: '#5d6b81' },
        { field: 'progressColor', colorIndex: 2 }, { field: 'titleColor', colorValue: '#5d6b81' },
        { field: 'progressColor', colorValue: '#35D0E6' }, { field: 'progressBg', colorValue: 'rgba(115,109,109,15%)' },
        { field: 'borderRadius', colorValue: 0 },
        { field: 'titleSize', colorValue: 18 },
        ],
        text: ['titleColor']
    },
    'cpt-chart-scatter': {
        fill: [{ field: 'color' }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color']
    },
    'cpt-chart-radar': {
        fill: [{ field: 'colors', colorValue: ['#95ebed', '#afacfc', '#deb4b4', '#bde88b', '#d9c0a7', '#f7b2b2'] }, { field: 'legend.left', colorValue: "center" },
        { field: 'legend.top', colorValue: 'top' },
        { field: 'legend.orient', colorValue: 'horizontal' },
        { field: 'legend.textStyle.fontSize', colorValue: '18' },
        { field: 'legend.textStyle.color', colorValue: '#5d6b81' },
        { field: 'radar.axisName.color', colorValue: '#5d6b81' },
        { field: 'radar.splitLine.lineStyle.color', colorValue: ['#5d6b81', '#5d6b81'] },
        { field: 'radar.axisLine.lineStyle.color', colorValue: '#5d6b81' },
        { field: 'title.textStyle.color', colorValue: '#5d6b81' },

        ],

        text: ['legend.textStyle.color']
    },
    'cpt-chart-funnel': {
        fill: [{ field: 'color' }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'series.label.color']
    },
    'cpt-chart-map-gc': {
        fill: [{ field: 'color' }],
        text: ['titleColor', 'subTitleColor', 'geoLabelColor', 'visualMap.textStyle.color']
    },
    'cpt-chart-map-migrate': {
        fill: [{ field: 'color' }, { field: 'map.areaColor', colorIndex: 0 }, { field: 'map.borderColor', colorIndex: 4 }, { field: 'map.shadowColor', colorIndex: 1 },
        { field: 'line.lineStyle.color', colorIndex: 3 }, { field: 'line.endPoint.itemStyle.color', colorIndex: 3 }, { field: 'effectScatter.itemStyle.color', colorIndex: 5 }],
        text: ['title.textStyle.color', 'map.color', 'visualMap.textStyle.color']
    },
    'cpt-chart-map-3d': {
        fill: [{ field: 'itemStyle.color', colorIndex: 0 }, { field: 'itemStyle.borderColor', colorIndex: 2 }, { field: 'barColor', colorIndex: 3 }],
        text: ['label.color']
    },
    'cpt-chart-map-3d-line': {
        fill: [{ field: 'color' }, { field: 'itemStyle.borderColor', colorIndex: 4 }, { field: 'itemStyle.color', colorIndex: 3 },
        { field: 'bar.color', colorIndex: 1 }, { field: 'line.lineStyle.color', colorIndex: 4 }],
        text: ['title.textStyle.color', 'label.color', 'visualMap.textStyle.color']
    },
    'cpt-time-run': {
        fill: [{ field: 'num.color', colorIndex: 1 }],
        text: ['label.color']
    },
    'cpt-chart-line-dual': {
        fill: [{ field: 'color' }, { field: 'yAxis[0].axisLine.lineStyle.color', colorIndex: 0 }, { field: 'yAxis[1].axisLine.lineStyle.color', colorIndex: 2 }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'series.label.color']
    },
    'cpt-chart-line-multiple': {
        fill: [{ field: 'color' }],
        text: ['title.textStyle.color', 'legend.textStyle.color', 'xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'series.label.color']
    },
    'cpt-chart-polycyclic': {
        fill: [{ field: 'color' }, { field: 'hartColor' }, { field: 'legendColor', colorValue: '#5d6b81' }],
    },
    'cpt-scroll-list': {
        text: ['color'],
    },
    'cpt-water-prop': {
        fill: [{ field: 'outline.borderColorTop', colorIndex: 0 }, { field: 'outline.borderColorBottom', colorIndex: 1 }, { field: 'colorTop', colorIndex: 2 }, { field: 'colorBottom', colorIndex: 3 },
        { field: 'backgroundColorTop', colorIndex: 3 }, { field: 'backgroundColorBottom', colorIndex: 4 },
        { field: 'colorTop', colorValue: '#66c8cc' },
        { field: 'colorBottom', colorValue: '#50aaad' },
        { field: 'backgroundColorTop', colorValue: '#52ccd1' },
        { field: 'backgroundColorBottom', colorValue: '#52ccd1' },
        { field: 'outline.borderColorTop', colorValue: '#3adae0' },
        { field: 'outline.borderColorBottom', colorValue: '#3adae0' },
        { field: 'outline.shadowColor', colorValue: 'rgba(0,0,0,0)' },

        ],
        text: ['label.color', 'label.insideColor'],
    },
    'cpt-chart-rect-stack': {
        fill: [{ field: 'colors' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'yAxis.axisLabel.color', 'yAxis.axisLine.lineStyle.color', 'title.textStyle.color']
    },
    'cpt-chart-wordcloud': {
        fill: [{ field: 'color' }]
    },
    'cpt-chart-line-3d': {
        fill: [{ field: 'color' }],
        text: ['xAxis.axisLabel.color', 'xAxis.axisLine.lineStyle.color', 'xAxis.splitLine.lineStyle.color',
            'yAxis.axisLabel.textStyle.color', 'yAxis.axisLine.lineStyle.color', 'yAxis.splitLine.lineStyle.color',
            'title.textStyle.color', 'series.label.color']
    },
}


// export const updateThemeOption = function (cptKey, option, themeIndex, textColor) {
//     const colorFieldsTypes = themeIndex == 1 ? lightColorFields : colorFields

//     if (!colorFieldsTypes[cptKey]) return option
//     if (colorFieldsTypes[cptKey].fill) {
//         colorFieldsTypes[cptKey].fill.forEach(cfg => {
//             const oldColor = eval('option.attribute.' + cfg.field)
//             // eslint-disable-next-line no-unused-vars
//             let tempColorArr = themeGroup[themeIndex].colors[cfg.colorIndex || 0]
//             if (oldColor instanceof Array) {
//                 tempColorArr = themeGroup[themeIndex].colors.slice(0, oldColor.length);
//             }

//             if (cfg?.colorValue) {
//                 let colorValue = cfg.colorValue
//                 eval('option.attribute.' + cfg.field + '=colorValue')
//             } else {
//                 eval('option.attribute.' + cfg.field + '=tempColorArr')
//             }
//         })
//     }
//     if (colorFieldsTypes[cptKey].text) {
//         colorFieldsTypes[cptKey].text.forEach(field => {
//             eval('option.attribute.' + field + '=textColor')
//         })
//     }
//     return option
// }


// eslint-disable-next-line no-unused-vars
export const updateThemeOption = function (cptKey, option, themeIndex, textColor) {
   // console.log('updateThemeOption', cptKey, option, themeIndex, textColor)
    let colorFieldsTypes = themeIndex == 1 ? lightColorFields : colorFields
    if (!colorFieldsTypes[cptKey]) return option
    // console.log(cptKey, option, themeIndex, textColor);
    try {
        if (colorFieldsTypes[cptKey].fill) {
            colorFieldsTypes[cptKey].fill.forEach(cfg => {
                const oldColor = eval('option.attribute.' + cfg.field)
                if (cfg?.colorValue != undefined) {
                    let color = cfg.colorValue
                    eval('option.attribute.' + cfg.field + '=color')
                } else if (cfg?.value) {
                    let value = cfg.value
                    eval('option.attribute.' + cfg.field + '=value')
                } else {
                    let tempColorArr = themeGroup[themeIndex]?.colors[cfg.colorIndex || 0]

                    if (oldColor instanceof Array) {

                        if (cptKey == 'cpt-dataV-waterLevel' && themeIndex == 0) {
                            tempColorArr = ['#3adae0', '#3adae0']

                        } else {
                            tempColorArr = themeGroup[themeIndex]?.colors.slice(0, oldColor.length);
                        }
                    }
                    eval('option.attribute.' + cfg.field + '=tempColorArr')



                }

            })
        }
        if (themeIndex != 1) {
            if (colorFieldsTypes[cptKey]?.text) {
                colorFieldsTypes[cptKey].text.forEach(field => {
                    eval('option.attribute.' + field + '=textColor')
                })
            }

            setChartTheme(cptKey, option, colorFieldsTypes[cptKey], {
                fontColor: '#6aa9e4',
                xAxisLineColor: '#02438e',
            })

        } else {

            setChartTheme(cptKey, option, colorFieldsTypes[cptKey], {
                fontColor: '#5d6b81',
                xAxisLineColor: '#8695a6',
                yAxisSplitLineLColor: ['#aaaaaa', '#aaaaaa'],
                yAxisSplitLineType: 'dashed'
            })
        }
    } catch (err) {
        console.log(err)
    }

    return option
}

const setChartTheme = (cptKey, option, colorFieldList, { fontColor, xAxisLineColor, yAxisSplitLineLColor, yAxisSplitLineType }) => {
    try {

        if (colorFieldList?.text) {
            colorFieldList?.text.forEach(field => {

                let isFontColorSet = ['yAxis.axisLabel', 'xAxis.axisLabel', 'title.textStyle', 'legend.textStyle']
                if (isFontColorSet.some(x => field.includes(x))) {
                    eval('option.attribute.' + field + '=fontColor')
                }
                if (field.includes('xAxis.axisLine')) {
                    eval('option.attribute.' + field + '=xAxisLineColor')
                }


                // 设置网格线
                if (cptKey.includes('cpt-chart')) {
                    if (yAxisSplitLineLColor) eval('option.attribute.yAxis.splitLine.lineStyle.color=yAxisSplitLineLColor')
                    if (yAxisSplitLineType) eval('option.attribute.yAxis.splitLine.lineStyle.type=yAxisSplitLineType')
                }


            })
        }
    } catch (error) {
        console.log(error)
    }

}


